import React from 'react';
import Table from '../../UI/Table/Table';
import DeleteButton from '../../UI/Buttons/DeleteButton';
import EditButton from '../../UI/Buttons/EditButton';
import {PaymentMethodEnum} from '../../Models/CommonEnum';
import settingGreenIcon from '../../assets/settingGreenIcon.png';
import {useLocale} from '../../Localization/LocaleContext';

const payment_method_columns = [
  {
    title: 'Name',
    key_name: 'name',
    feature_activated: true,
  },
  {
    title: 'Actions',
    key_name: 'actions',
    feature_activated: true,
  },
  {
    title: 'Minimum Amount',
    key_name: 'min_amount',
    feature_activated: true,
  },
  {
    title: 'Maximum Amount',
    key_name: 'max_amount',
    feature_activated: true,
  },
  {
    title: 'Default',
    key_name: 'default',
    feature_activated: true,
  },
  {
    title: 'Order',
    key_name: 'order_by',
    feature_activated: true,
  },
  {
    title: 'Status',
    key_name: 'status',
    feature_activated: true,
  },
];

const PaymentMethodList = ({
  onPaymentMethodClick,
  payment_methods_list,
  writeP,
  deleteP,
  onDeletePaymentMethod,
  onEditPaymentMethod,
  onSettingClick,
}) => {
  const {translate: t} = useLocale();
  return (
    <Table
      header_data={payment_method_columns
        ?.filter(it => it.feature_activated)
        .map(item => {
          const center_keys = [
            'min_amount',
            'max_amount',
            'default',
            'status',
            'actions',
            'order_by',
          ];
          return {
            title: t(`payments.table_${item.key_name}`, item.title),
            key: item.key_name,
            className: [
              'text-sm font-medium px-4 py-3 flex-grow whitespace-nowrap w-[10%]',
              center_keys?.includes(item?.key_name)
                ? 'text-center'
                : 'text-start',
            ].join(' '),
          };
        })}
      table_header_style={'w-full max-w-full'}
      table_style=" w-full block border-0 rounded-none !mt-0 table-auto w-full max-h-[90%] h-full overflow-auto overflow-auto ">
      {payment_methods_list?.map((paymentMethod, paymentMethodIndex) => {
        return (
          <tr
            key={`payment-method-${paymentMethod?.id || paymentMethod?.name || 'item'}-${paymentMethodIndex}`}
            className="w-full border-b border-[var(--color-border)] bg-[var(--color-surface)]">
            {payment_method_columns
              ?.filter(it => it?.feature_activated)
              ?.map((column, columnIndex) => {
                switch (column.key_name) {
                  case 'name':
                    return (
                      <td
                        key={`${column.key_name}-${columnIndex}`}
                        onClick={() => onPaymentMethodClick(paymentMethod?.id)}
                        className="p-2 text-primary min-w-[300px] cursor-pointer hover:underline">
                        {paymentMethod?.name}
                      </td>
                    );

                  case 'min_amount':
                    return (
                      <td
                        key={`${column.key_name}-${columnIndex}`}
                        className="p-2 px-4 whitespace-nowrap text-AppTitleBlack text-center">
                        {paymentMethod?.min_amount || '-'}
                      </td>
                    );

                  case 'max_amount':
                    return (
                      <td
                        key={`${column.key_name}-${columnIndex}`}
                        className="p-2 px-4 whitespace-nowrap text-AppTitleBlack text-center">
                        {paymentMethod?.max_amount || '-'}
                      </td>
                    );

                  case 'default':
                    return (
                      <td
                        key={`${column.key_name}-${columnIndex}`}
                        className="p-2 whitespace-nowrap">
                        <p
                          className={`p-1 rounded w-fit mx-auto ${
                            paymentMethod?.default
                              ? 'btn-active'
                              : 'btn-deactivate'
                          }`}>
                          {paymentMethod?.default ? t('payments.yes', 'Yes') : t('payments.no', 'No')}
                        </p>
                      </td>
                    );

                  case 'order_by':
                    return (
                      <td
                        key={`${column.key_name}-${columnIndex}`}
                        className="p-2 px-4 whitespace-nowrap text-AppTitleBlack text-center">
                        {paymentMethod?.order_by}
                      </td>
                    );

                  case 'status':
                    return (
                      <td
                        key={`${column.key_name}-${columnIndex}`}
                        className="p-2 whitespace-nowrap">
                        <p
                          className={`p-1 rounded w-fit mx-auto ${
                            paymentMethod?.active
                              ? 'btn-active'
                              : 'btn-deactivate'
                          }`}>
                          {paymentMethod?.active ? t('payments.active', 'Active') : t('payments.inactive', 'Inactive')}
                        </p>
                      </td>
                    );

                  case 'actions':
                    const showSetting = [
                      PaymentMethodEnum.opp,
                      PaymentMethodEnum.stripe,
                      PaymentMethodEnum.stripe_web,
                      PaymentMethodEnum.payulatam,
                      PaymentMethodEnum.razorpay,
                      PaymentMethodEnum.paydunya,
                      PaymentMethodEnum.mangopay,
                      PaymentMethodEnum.billplz,
                      PaymentMethodEnum.pawapay,
                      PaymentMethodEnum.korapay,
                      PaymentMethodEnum.paystack,
                      PaymentMethodEnum.flutterwave,
                      PaymentMethodEnum.commercepay,
                      PaymentMethodEnum.checkout_dot_com,
                    ].includes(paymentMethod?.type);

                    return (
                      <td
                        key={`${column.key_name}-${columnIndex}`}
                        className="p-2 px-4 text-AppTitleBlack min-w-[200px]">
                        <div className="flex items-center justify-center gap-2">
                          {deleteP && (
                            <DeleteButton
                              onClickDelete={() =>
                                onDeletePaymentMethod(paymentMethod?.id)
                              }
                            />
                          )}
                          {writeP && (
                            <EditButton
                              onClickEdit={() =>
                                onEditPaymentMethod(paymentMethod?.id)
                              }
                            />
                          )}
                          {showSetting && writeP && (
                            <button
                              onClick={() => onSettingClick(paymentMethod?.id)}
                              className="p-1">
                              <img
                                src={settingGreenIcon}
                                alt={t('payments.settings', 'Settings')}
                                className="h-5 w-5"
                              />
                            </button>
                          )}
                          {!writeP && !deleteP && t('payments.not_available', 'N/A')}
                        </div>
                      </td>
                    );

                  default:
                    return null;
                }
              })}
          </tr>
        );
      })}
    </Table>
  );
};

export default PaymentMethodList;
